import { useCallback } from 'react'
import { isPausedOn } from '@trackmind/core'
import { useToday } from '@/hooks/useToday'

/**
 * "Is this paused today?" — core's rule, on the user's today.
 *
 * Screens read `task.is_paused` directly, which stays true after a pause with
 * an end date has passed: the scheduler planned the work again while the
 * Dashboard still listed it under Paused, Analytics left the habit out and
 * the task card hid its "Unscheduled" badge. Use this instead.
 */
export function useIsPaused(): (task: { is_paused?: boolean; paused_until?: string | null }) => boolean {
  const todayKey = useToday()
  return useCallback((task) => isPausedOn(task, todayKey()), [todayKey])
}
